import styled from "styled-components"
import Button from "../../atoms/buttons/Button"
import { ArrowRight } from "../../atoms/icons/ArrowRight"
import ResourceCard from "../../atoms/ResourceCard"
import H1 from "../../atoms/typography/H1"
import H3 from "../../atoms/typography/H3"

const ReadMoreNewsCardStyle = styled.div`
  height: 100%;
  padding-inline: 2rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  row-gap: 2rem;

  a {
    align-self: stretch;
  }
`

const ReadMoreNewsCard: React.FunctionComponent = () => {
  return (
    <ResourceCard key="discover-all-news">
      <ReadMoreNewsCardStyle>
        <H1 bold>Want to read more?</H1>
        <H3>Want to read more? Find out more about Satcube and our products by browsing through all our resources.</H3>
        <Button variant="yellow" iconRight={<ArrowRight />} title="Discover all news" link="/news" />
      </ReadMoreNewsCardStyle>
    </ResourceCard>
  )
}

export default ReadMoreNewsCard
